window.less = {
    // To disable any attempt to transpile LESS to CSS from style tags with rel="stylesheet/less" since that would
    // lead to an unwanted console message saying: "Less has finished and no sheets were loaded."
    onReady: false
};
